import { AppConfig } from "./AppConfig.js";

// Permisos del usuario en este sistema, resueltos una vez al iniciar (main.js).
// Sólo deciden qué se muestra: la API vuelve a validar cada permiso contra LCApii.
const tiene = (pid) => pid > 0 && Sesion.permisos.includes(pid);

export const Sesion = {
  permisos: [],
  puedeIngresar: () => tiene(AppConfig.lcapii.permisos.ingresar),
  puedeEliminarInventario: () => tiene(AppConfig.lcapii.permisos.eliminarInventario),
  puedeEliminarMuestreo: () => tiene(AppConfig.lcapii.permisos.eliminarMuestreo),
  puedeGestionarEquipos: () => tiene(AppConfig.lcapii.permisos.gestionarEquipos),
};
